<template>
  <Tag class="text-xs! h-7!" :severity="getSeverity()">{{ getCategory() }}</Tag>
</template>

<script setup lang="ts">
import { TemplateColumnCategory } from "@/enums/TemplateColumnCategory";
const props = defineProps(["params"]);

const convertToExcelColumn = (index: number): string => {
  if (index < 26) return numberToColumn(index);
  return convertToExcelColumn(Math.floor(index / 26) - 1) + numberToColumn(index % 26);
};

const numberToColumn = (index: number): string => {
  if (index >= 26 || index < 0) throw "Index must be between 0 and 25: " + index;
  return String.fromCharCode(65 + index);
};

const getCategory = (): string => {
  switch (props.params.data.category) {
    case TemplateColumnCategory.CUSTOM_FIELD:
      return "Custom";
    case TemplateColumnCategory.FLEX_ROW:
      return "Flex";
    case TemplateColumnCategory.STOCK_BUDGET_ITEM:
      return "Budget";
    default:
      return "Normal";
  }
};

const getSeverity = (): string => {
  switch (props.params.data.category) {
    case TemplateColumnCategory.CUSTOM_FIELD:
      return "success";
    case TemplateColumnCategory.FLEX_ROW:
      return "danger";
    case TemplateColumnCategory.STOCK_BUDGET_ITEM:
      return "help";
    default:
      return "info";
  }
};
</script>
